// Owner-side inbox for messages from the agency. Pairs with the super-admin
// CRM drawer's Messages tab — same backend store, different perspective.
import React, { useEffect, useState } from 'react';
import { G, styles, api } from '../theme.js';
import { Btn, Spinner } from '../ui.jsx';

export function AgencyInbox({ toast }) {
  const [msgs, setMsgs] = useState(null);
  const [draft, setDraft] = useState('');
  const load = () => api('/api/agency/inbox').then(setMsgs).catch(()=>setMsgs([]));
  useEffect(() => { load(); }, []);

  // Mark unread as read after they're rendered (one-shot per load)
  useEffect(() => {
    if (!msgs) return;
    const unread = msgs.filter(m => m.direction === 'from_agency' && !m.read_at);
    unread.forEach(m => api(`/api/agency/inbox/${m.id}/read`, { method:'POST' }).catch(()=>{}));
  }, [msgs]);

  const send = async () => {
    if (!draft.trim()) return;
    try { await api('/api/agency/inbox', { method:'POST', body:{ body: draft }}); setDraft(''); load(); toast('✓ Sent'); }
    catch (e) { toast(e.message, 'error'); }
  };

  return <div style={{ padding:24, maxWidth:760 }}>
    <h1 style={{ margin:'0 0 6px', fontSize:24, fontWeight:800 }}>📩 Agency Inbox</h1>
    <div style={{ color:G.textMuted, fontSize:13, marginBottom:18 }}>
      Direct line to your agency. Product updates, support, billing questions — everything in one thread.
    </div>

    <div style={{ ...styles.card, padding:0, maxHeight:'60vh', overflowY:'auto', marginBottom:12 }}>
      {!msgs ? <div style={{ padding:30, textAlign:'center' }}><Spinner sz={20}/></div>
        : msgs.length === 0 ? <div style={{ padding:30, color:G.textMuted, fontSize:13, textAlign:'center' }}>No messages yet.</div>
        : msgs.slice().reverse().map(m => (
          <div key={m.id} style={{ padding:'12px 16px', borderBottom:`1px solid ${G.border}`, background: m.direction === 'from_owner' ? 'transparent' : G.purpleDim+'33' }}>
            <div style={{ display:'flex', justifyContent:'space-between', fontSize:11, color:G.textMuted, marginBottom:4 }}>
              <strong style={{ color: m.direction === 'from_owner' ? G.cyan : G.purple }}>
                {m.direction === 'from_owner' ? '→ You' : `← ${m.author_email || 'Your agency'}`}
              </strong>
              <span>{new Date(m.created_at).toLocaleString()}</span>
            </div>
            <div style={{ fontSize:14, whiteSpace:'pre-wrap', lineHeight:1.5 }}>{m.body}</div>
          </div>
        ))}
    </div>

    <div style={{ display:'flex', gap:8 }}>
      <textarea value={draft} onChange={e=>setDraft(e.target.value)} rows={2} placeholder="Reply to your agency…"
        style={{ flex:1, padding:10, background:G.input, color:G.text, border:`1px solid ${G.cardBorder}`, borderRadius:8, fontSize:14, resize:'vertical', fontFamily:'inherit' }}/>
      <Btn v="primary" onClick={send} disabled={!draft.trim()}>Send</Btn>
    </div>
  </div>;
}
